/* Bazaar theme — scroll-snap carousels */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.carouselReady === '1') return;
    root.dataset.carouselReady = '1';

    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    var slides = Array.prototype.slice.call(track.children);

    function step() {
      if (root.dataset.scrollBy === 'page') return Math.round(track.clientWidth * 0.85);
      return track.clientWidth;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    /* Dots — only for full-width slideshows */
    var dots = [];
    if (dotsWrap && slides.length > 1) {
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'carousel__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function currentIndex() {
      var pos = track.scrollLeft + track.clientWidth / 2;
      for (var i = 0; i < slides.length; i++) {
        var left = slides[i].offsetLeft - track.offsetLeft;
        if (pos >= left && pos < left + slides[i].offsetWidth) return i;
      }
      return 0;
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateArrows();
        if (dots.length) {
          var idx = currentIndex();
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', updateArrows);
    updateArrows();

    /* Autoplay for hero slideshows */
    if (root.dataset.autoplay === 'true' && slides.length > 1) {
      var interval = parseInt(root.dataset.interval, 10) || 6000;
      var timer = setInterval(advance, interval);

      function advance() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (track.scrollLeft >= max) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        }
      }

      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', function () { timer = setInterval(advance, interval); });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { clearInterval(timer); } else { timer = setInterval(advance, interval); }
      });
    }
  }

  function initAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-carousel]')).forEach(init);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('theme:rerender', function (e) { initAll(e.detail && e.detail.target); });
})();
